import type { UnifiedProject } from '@apis/projects';
import { readLastSiteId } from '@utils/lastSite';

/**
 * Which of the user's sites to work in: the one the route names, else the one
 * they used last (if they still have it), else their first.
 */
export function pickSite(projects: UnifiedProject[], routeSiteId: string | null): UnifiedProject | null {
  if (routeSiteId) {
    const byRoute = projects.find((p) => p.siteId === routeSiteId);
    if (byRoute) return byRoute;
  }
  const lastSiteId = readLastSiteId();
  if (lastSiteId) {
    const byLast = projects.find((p) => p.siteId === lastSiteId);
    if (byLast) return byLast;
  }
  return projects[0] ?? null;
}
